import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import NotifyMe from "@/components/starterkit/NotifyMe";
import { useKitAvailability } from "@/lib/kitAvailability";
import { productImg } from "@/lib/img";

function KitCard({ sport, age }) {
  const { sports, label } = useKitAvailability();
  const live = sport && sports.includes(sport);
  const q = live ? `?sport=${encodeURIComponent(sport)}${age ? `&age=${age}` : ""}` : "";
  const sportName = live ? sport : sports.length === 1 ? sports[0] : "";
  return (
    <div data-testid="article-offer-kit" className="border-2 border-[#1E1E1E] bg-[#222222] p-5 sm:p-6 text-[#F5F0EA]">
      <span className="font-head uppercase tracking-[0.2em] text-xs text-[#DB9130]">Just got voluntold? · $9</span>
      <h3 className="mt-2 font-head font-semibold uppercase text-xl leading-tight">The Starter Kit</h3>
      <p className="mt-2 text-sm text-[#C9C3B6] leading-relaxed">
        Practice plans, a rotation sheet and first-week scripts built for your team in minutes.
      </p>
      {label && <p className="mt-2 text-xs text-[#F5F0EA]" data-testid="article-offer-kit-label"><b>Available now:</b> {live && age ? `${sport}, ages ${age}` : label}</p>}
      <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
        <Link to="/starter-kit#notify" data-testid="article-offer-kit-notify" className="text-xs text-[#A9B6BF] underline underline-offset-4 hover:text-[#DB9130]">Other sport? Join the waitlist</Link>
        <Link to={`/starter-kit${q}`} data-testid="article-offer-kit-btn" className="group inline-flex items-center gap-1 font-head uppercase text-sm text-[#DB9130] whitespace-nowrap">
          {sportName ? `Build my ${sportName} kit` : "Build my kit"} <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  );
}

function ProductCard({ p }) {
  return (
    <Link to={p.lookup_key ? `/shop/${p.lookup_key}` : "/shop"} data-testid={`article-offer-product-${p.lookup_key}`}
      className="group flex gap-4 border-2 border-[#D3CFC0] bg-[#E7E3D9] p-4 hover:border-[#2D2D2D] transition-colors">
      {p.image && <img {...productImg(p.image, "80px")} alt={p.name} loading="lazy" decoding="async" className="w-20 h-20 object-contain bg-[#F3F1EC] shrink-0" />}
      <div className="min-w-0">
        <span className="kicker text-[#6E6E6E]">Goes with this read</span>
        <h4 className="font-head font-semibold text-base text-[#1E1E1E] !leading-[1.3] mt-1">{p.name}</h4>
        <p className="mt-1 text-xs text-[#6E6E6E] line-clamp-2">{p.blurb}</p>
        <span className="mt-1 inline-block font-head text-sm text-[#1E1E1E]">${p.amount / 100} · See the details →</span>
      </div>
    </Link>
  );
}

export function ArticleOffer({ slug }) {
  const [o, setO] = useState(null);
  useEffect(() => { api.get(`/articles/${slug}/offer`).then(({ data }) => setO(data)).catch(() => setO(null)); }, [slug]);
  if (!o) return null;
  return (
    <section className="mt-10 max-w-xl" data-testid="article-offer">
      {o.show === "notify" && <div data-testid="article-offer-notify"><NotifyMe sports={[o.sport]} /></div>}
      {o.show === "starter_kit" && <KitCard sport={o.sport} age={o.age} />}
      {o.show === "product" && o.product && <ProductCard p={o.product} />}
    </section>
  );
}
